module.exports = __webpack_public_path__ + "static/img/lunbo2.9a3d703d.png";